import React from 'react';
import styles from './style.module.scss';
import InsightsChart from 'components/pages/area-listings/components/market-insights/insights-chart';
import { useTranslation } from 'next-i18next';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

import type { InsightsResponse } from '@zoocasa/go-search';

export interface PriceTrendsProps {
  /** The insights data containing price trend information */
  insightsData?: InsightsResponse;
  /** The name of the area for display */
  areaName?: string;
}

/**
 * Displays a chart showing historical price trends for an area.
 * Reuses the existing InsightsChart component from area-listings.
 */
const PriceTrends = ({ insightsData, areaName }: PriceTrendsProps) => {
  const { t } = useTranslation(Namespaces.COMMON);

  if (!insightsData?.medianPriceTrends || insightsData.medianPriceTrends.length === 0) {
    return null;
  }

  return (
    <section className={styles.component}>
      <h2 className={styles.heading}>
        {areaName
          ? t(LOCALE_COMMON_PATHS.CITYINFO_PRICETRENDS_HEADINGWITHAREA, { areaName, defaultValue: 'Price Trends in {{areaName}}' })
          : t(LOCALE_COMMON_PATHS.CITYINFO_PRICETRENDS_HEADING, { defaultValue: 'Price Trends' })}
      </h2>
      <div className={styles.chartContainer}>
        <InsightsChart insightsData={insightsData} />
      </div>
    </section>
  );
};

export default PriceTrends;
